<div class="container footerContainer">
  <footer class="row row-cols-1 row-cols-sm-2 row-cols-md-5 py-5 my-5 border-top">
    <div class="col mb-3">
      <a href="/" class="d-flex align-items-center mb-3 link-body-emphasis text-decoration-none">
        <img src="assets/img/medilinkLogo.svg" alt="">
      </a>
      <div class="logos">
        <i class="bi bi-instagram"></i>
        <i class="bi bi-facebook"></i>
        <i class="bi bi-linkedin"></i>
        <i class="bi bi-youtube"></i>
      </div>
      <div class="navTiny">
        <ul>
          <li><a href="">Preguntas Frecuentes</a></li>
          <li><a href="">Preguntas Frecuentes</a></li>
          <li><a href="">Preguntas Frecuentes</a></li>
          <li><a href="">Preguntas Frecuentes</a></li>
          <li><a href="">Preguntas Frecuentes</a></li>
          <li><a href="">Preguntas Frecuentes</a></li>
          <li><a href="">Preguntas Frecuentes</a></li>
        </ul>
      </div>
    </div>


    <div class="col mb-3">

    </div>

    <div class="col mb-6 sucursalesNamesList">
      <h3>Visitanos en nuestras sucursales</h3>
      <ul class="nav flex-column">
        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-body-secondary"><app-sucursal-location/></a></li>
      </ul>
    </div>



  </footer>
</div>



